<template>
  <div>
    <div class="notify-left">
      <img src="https://assets.sororitywars.app/icons/notify/V2/burn_list.png" width="40" height="40" class="desktop-notify-image" />
    </div>
    <div class="notify-right">
      <button type="button" class="notify-close" aria-label="Dismiss notification" @click="$emit('closeMe')">&times;</button>
      <div class="notify-alert">Live alert</div>
      <div class="notify-title" v-if="notif.entry.content.lister.id === myID">
        <router-link class="pink" :to="{ name: 'SororityWarsProfileHome', params: { playerId: notif.entry.content.offender.id } }">
          {{notif.entry.content.offender.name}}
        </router-link>
        claimed the reward of ${{$number.withCommas(notif.entry.content.amount)}} for terminally depressing
        <router-link class="pink" :to="{ name: 'SororityWarsProfileHome', params: { playerId: notif.entry.content.target.id } }">
        {{notif.entry.content.target.name}}
      </router-link>
      </div>
      <div class="notify-title" v-if="notif.entry.content.target.id === myID">
        You were taken off of the burn list by
        <router-link class="pink" :to="{ name: 'SororityWarsProfileHome', params: { playerId: notif.entry.content.offender.id } }">
          {{notif.entry.content.offender.name}}
        </router-link>!
      </div>
    </div>
    <router-link class="notify-image pink" :to="{ name: 'SororityWarsProfileHome', params: { playerId: notif.entry.content.offender.id } }">
      <img src="https://assets.sororitywars.app/icons/notify/V2/burn_list.png" width="40" height="40" class="notify-image" @click="$emit('closeMe')" />
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'BurnListExecute',
  props: {
    notif: {
      type: Object,
      required: true
    }
  },
  computed: {
    myID () {
      return this.$store.state.user.id
    }
  }
}
</script>

<style scoped>

</style>
